import { MakeInlineWCCContentBlock } from 'components/content/mixins/inline';
import { MakeWCCContentBlockWithLimit } from 'components/content/mixins/limit';
import { MakeWCCContentBlockWithMerge } from 'components/content/mixins/merge';
import { MakeWCCContentBlockWithSplit } from 'components/content/mixins/split';
import { Constructor } from 'interfaces/constructor';
import { WCCContentBlock } from '../block/block';
import { IWCCContentBlock, WCCContentBlockConfig } from '../block/block.interfaces';

function setupConfig(config: WCCContentTextBlockConfig | string): WCCContentTextBlockConfig {
    if (_.isString(config))
        return { content: config };

    return config;
}

const ExtendedWCCContentBlock = [
    MakeInlineWCCContentBlock,
    MakeWCCContentBlockWithLimit(),
    MakeWCCContentBlockWithSplit,
    MakeWCCContentBlockWithMerge
].reduce((result, mixin) => mixin(result), <Constructor<any[], WCCContentBlock<WCCContentTextBlockConfig>>>WCCContentBlock);

export interface WCCContentTextBlockConfig extends WCCContentBlockConfig {
    noTrim?: boolean
}

export class WCCContentTextBlock extends ExtendedWCCContentBlock {
    private prevBlock = ko.observable<IWCCContentBlock>();

    private noTrim() {
        return this.config.noTrim ?? false;
    }

    constructor(config: WCCContentTextBlockConfig | string) {
        super(setupConfig(config));        
    }

    override optimize(prev: IWCCContentBlock) {
        super.optimize(prev);

        this.prevBlock(prev);
    }

    protected override getNodes() {
        const prevBlock = this.prevBlock();

        let text = this.content;

        if (prevBlock != undefined && prevBlock.type != 'container') {
            if (prevBlock.type == 'embed')
                text = text.replace(/^\r?\n/, '');

            text = text
                .replace(/^\s+/, (match) => match.replace(/\n/g, '</br>'))
                .replace(/(\S+)(\s+)$/, (match, left, spaces) => left + spaces.replace(/\n/g, '</br>'));

            if (prevBlock.type == 'embed')
                text = text.replace(/^\s+/, '');
        } else if (!this.noTrim) {
            text = text.trim().replace(/\n/g, '</br>');
        }

        return text.length > 0 ? ko.utils.parseHtmlFragment(text) : [];
    }
}